import i18n from '@remind/i18n';
import jwt from 'lib/jsonwebtoken';
import React, { Component } from 'react';
import { Container } from 'flux/utils';

import AuthActions from 'auth/AuthActions';
import BoxBody from 'components/BoxBody.jsx';
import BoxFooter from 'components/BoxFooter.jsx';
import DialogButton from 'components/DialogButton.jsx';
import Copy from 'components/Copy.jsx';
import CurrentUser from 'auth/CurrentUser';
import DeviceActions from 'actions/DeviceActions';
import DeviceStore from 'stores/DeviceStore';
import DialogContent from 'components/DialogContent.jsx';
import ErrorActions from 'actions/ErrorActions';
import Link from 'components/Link.jsx';
import UserActions from 'user/UserActions';

export class EmailUnsubscribeView extends Component {
  static onEnter(nextState, replaceWith, callback) {
    AuthActions.jwtTokenSignIn(nextState.params.token);

    // Load the device
    UserActions.loadCurrentUser(nextState.params.token)
      .then(() => {
        return DeviceActions.loadDevices();
      }, () => {
        ErrorActions.expiredToken('EMAIL_UNSUBSCRIBE');
        replaceWith('/error');
        callback();
      })
      .then(() => {
        const payload = jwt.decode(CurrentUser.getToken());
        const device = DeviceStore.getDevice(payload.device_id);

        if (!device) {
          replaceWith('/error');
        }

        callback();
      }, () => {
        replaceWith('/error');
        callback();
      });
  }

  static getStores() {
    return [CurrentUser, DeviceStore];
  }

  static calculateState() {
    const payload = CurrentUser.getToken() && jwt.decode(CurrentUser.getToken());
    const device = payload.device_id && DeviceStore.getDevice(payload.device_id);

    if (!device) {
      return {};
    }

    return { device, enabled: device.isEnabled() };
  }

  constructor(props) {
    super(props);

    const payload = CurrentUser.getToken() && jwt.decode(CurrentUser.getToken());
    const device = payload.device_id && DeviceStore.getDevice(payload.device_id);

    if (!device) {
      return {};
    }

    this.state = { device, enabled: device.isEnabled() };
  }

  handleDisableButtonClick = () => {
    DeviceActions.disable(this.state.device);
  }

  renderConfirmation() {
    return (
      <DialogContent
        size="small"
        title={<span>Are you sure you want to stop receiving messages from <b>all</b> your classes via email?</span>}
        glyph="caution"
        glyphColor="lava">
        <BoxBody>
          <Copy>
            <p>
              Click on the button below to stop receiving messages from all of your classes via email at {this.state.device.getLabel()}.
              If you’d like to edit your contact information, change your notification preferences,
              or download the Remind app,{' '}
              <Link to="/settings/notifications">visit your account</Link> instead.
            </p>
          </Copy>
          <DialogButton
            onClick={this.handleDisableButtonClick}>
            {i18n.getText('Unsubscribe')}
          </DialogButton>
        </BoxBody>
        <BoxFooter>
          Click
          {' '}
          <Link to="/settings/notifications">here</Link>
          {' '}
          to edit message preferences
        </BoxFooter>
      </DialogContent>
    );
  }

  renderDisabledMessage() {
    const title = i18n.getText(
      'Your email ({address}) is disabled from receiving Remind messages.',
      {
        address: this.state.device.getLabel(),
      }
    );
    const subtext = i18n.getText('You can now close this browser.');

    return (
      <DialogContent
        size="small"
        title={title}
        subtext={subtext}
      />
    );
  }

  render() {
    if (!this.state.device) {
      return null;
    } else if (this.state.enabled) {
      return this.renderConfirmation();
    } else {
      return this.renderDisabledMessage();
    }
  }
}

export default Container.create(EmailUnsubscribeView);



// WEBPACK FOOTER //
// ./src/user/components/EmailUnsubscribeView.jsx